module.exports = __webpack_public_path__ + "fonts/SourceHanSansCN-Normal.5750f527.ttf";